import packageJSON from '../package.json';

export const printWebappInfo = () => {
  console.group('Webapp info');
  console.log(`Webapp: ${packageJSON.name}`);
  console.log(`Version: ${packageJSON.version}`);
  console.groupEnd();
};
